import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { CategoriesEntity } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function CategoryCard({
  category,
  onClick,
  showArrow = false,
  className,
}: {
  category: CategoriesEntity;
  onClick?: () => void;
  showArrow?: boolean;
  className?: {
    container?: string;
    wrapper?: string;
  };
}) {
  return (
    <Link
      prefetch={false}
      onClick={onClick}
      href={ROUTES.CATEGORY({ slug: category.slug, page: 1 })}
      className={cn(
        'col-span-1 flex w-full items-center justify-between rounded-[8px] bg-white p-4',
        className?.container,
        'category-card__shadow',
      )}
    >
      <div className={cn('flex items-center justify-start gap-4', className?.wrapper)}>
        <Image
          src={category.image?.url || '/images/placeholder.png'}
          alt={resolveImageAlt(category?.image, category?.name)}
          width={0}
          height={0}
          className="min-h-[52px] min-w-[52px] object-cover object-center"
          sizes="52px"
        />
        <p className="text-sm font-normal text-foreground md:text-base">{category.name}</p>
      </div>
      {showArrow && <MdOutlineKeyboardArrowRight size={20} className="text-primary" />}
    </Link>
  );
}
